import { LANG_CODE_AUTO_GEN_SUBSTR } from '../../spa/types/common';
import { getLanguages } from '../../spa/store/models/selectors';
import { getState } from '../../spa/store';

export interface ILangsMap {
  [key: string]: string;
}

const allLanguages: ILangsMap = {
  ar: 'Arabic',
  de: 'German',
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  ja: 'Japanese',
  pt: 'Portuguese',
  ptbr: 'Portuguese (Brazil)',
  ru: 'Russian',
  zh: 'Chinese',
};

const LANG_PT_CODE = 'pt';
const LANG_PT_BR_CODE = 'ptbr';

const isoLangCodeMap: Record<string, string> = {
  [LANG_PT_BR_CODE] : 'pt-BR',
  [LANG_PT_CODE] : 'pt-PT'
}

export class LangUtil {

  private static langsMap: ILangsMap;

  public static getAllLanguages(): ILangsMap {
    let result = getLanguages(getState());
    if (!result || result.length < 1) {
      return {...allLanguages};
    }

    if (!LangUtil.langsMap) {
      LangUtil.langsMap = {};
      result.forEach(l => {
        LangUtil.langsMap[l.code] = l.name;
      })
    }
    return LangUtil.langsMap;
  }

  /*public static getAllLanguages(): ILangsMap {
    if (!LangUtil.langsMap) {
      LangUtil.langsMap = {};
      let result = getLanguages(getState());
      if (!result || result.length < 1) {
        LangUtil.langsMap = {...allLanguages};
      } else {
        result.forEach(l => {
          LangUtil.langsMap[l.code] = l.name;
        })
      }
    }
    return LangUtil.langsMap;
  }*/

  public static getLangNameByCode(code: string): string {
    const langs = LangUtil.getAllLanguages();
    return langs[this.checkLangCode(code)] || '';
  }

  public static checkLangCode(langCode?: string): string {
    if (!langCode) return '';
    let ps = langCode.indexOf('-');
    let result = ps >= 0 ? langCode.substring(0, ps) : langCode;
    const subCode = ps >= 0 ? langCode.substring(ps + 1).toLowerCase() : '';
    ps = result.indexOf(LANG_CODE_AUTO_GEN_SUBSTR);
    let code: string = ps >= 0 ? result.substring(0, ps) : result;

    if (code === LANG_PT_CODE) {
      if (subCode.startsWith('br')) {
        code = LANG_PT_BR_CODE;
      }
    }
    return code;
  }

  public static getIsoLangCode(code: string) {
    return isoLangCodeMap[code] || code;
  }

  // Endless-book's language picker takes English names from a fixed list (not ISO codes), and its
  // spellings diverge from ours for a few codes — override just those, everything else reuses our
  // own name map. Unknown code -> '' so endless-book falls back to its own default.
  private static ENDLESS_BOOK_NAME_OVERRIDES: ILangsMap = {
    zh: 'Mandarin Chinese',
    pt: 'Portuguese (Portugal)',
    ptbr: 'Portuguese (Brazil)',
  };

  public static getEndlessBookName(code?: string): string {
    const checked = LangUtil.checkLangCode(code);
    return LangUtil.ENDLESS_BOOK_NAME_OVERRIDES[checked] || LangUtil.getLangNameByCode(checked);
  }

}

//   ab: 'Abkhazian',
//   aa: 'Afar',
//   af: 'Afrikaans',
//   ak: 'Akan',
//   sq: 'Albanian',
//   am: 'Amharic',
//   ar: 'Arabic',
//   an: 'Aragonese',
//   hy: 'Armenian',
//   as: 'Assamese',
//   av: 'Avaric',
//   ae: 'Avestan',
//   ay: 'Aymara',
//   az: 'Azerbaijani',
//   bm: 'Bambara',
//   ba: 'Bashkir',
//   eu: 'Basque',
//   be: 'Belarusian',
//   bn: 'Bengali',
//   bh: 'Bihari languages',
//   bi: 'Bislama',
//   bs: 'Bosnian',
//   br: 'Breton',
//   bg: 'Bulgarian',
//   my: 'Burmese',
//   ca: 'Catalan, Valencian',
//   ch: 'Chamorro',
//   ce: 'Chechen',
//   ny: 'Chichewa, Chewa, Nyanja',
//   zh: 'Chinese',
//   cv: 'Chuvash',
//   kw: 'Cornish',
//   co: 'Corsican',
//   cr: 'Cree',
//   hr: 'Croatian',
//   cs: 'Czech',
//   da: 'Danish',
//   dv: 'Divehi, Dhivehi, Maldivian',
//   nl: 'Dutch, Flemish',
//   dz: 'Dzongkha',
//   en: 'English',
//   eo: 'Esperanto',
//   et: 'Estonian',
//   ee: 'Ewe',
//   fo: 'Faroese',
//   fj: 'Fijian',
//   fi: 'Finnish',
//   fr: 'French',
//   ff: 'Fulah',
//   gl: 'Galician',
//   ka: 'Georgian',
//   de: 'German',
//   el: 'Greek, Modern (1453–)',
//   gn: 'Guarani',
//   gu: 'Gujarati',
//   ht: 'Haitian, Haitian Creole',
//   ha: 'Hausa',
//   he: 'Hebrew',
//   hz: 'Herero',
//   hi: 'Hindi',
//   ho: 'Hiri Motu',
//   hu: 'Hungarian',
//   ia: 'Interlingua (International Auxiliary Language Association)',
//   id: 'Indonesian',
//   ie: 'Interlingue, Occidental',
//   ga: 'Irish',
//   ig: 'Igbo',
//   ik: 'Inupiaq',
//   io: 'Ido',
//   is: 'Icelandic',
//   it: 'Italian',
//   iu: 'Inuktitut',
//   ja: 'Japanese',
//   jv: 'Javanese',
//   kl: 'Kalaallisut, Greenlandic',
//   kn: 'Kannada',
//   kr: 'Kanuri',
//   ks: 'Kashmiri',
//   kk: 'Kazakh',
//   km: 'Central Khmer',
//   ki: 'Kikuyu, Gikuyu',
//   rw: 'Kinyarwanda',
//   ky: 'Kirghiz, Kyrgyz',
//   kv: 'Komi',
//   kg: 'Kongo',
//   ko: 'Korean',
//   ku: 'Kurdish',
//   kj: 'Kuanyama, Kwanyama',
//   la: 'Latin',
//   lb: 'Luxembourgish, Letzeburgesch',
//   lg: 'Ganda',
//   li: 'Limburgan, Limburger, Limburgish',
//   ln: 'Lingala',
//   lo: 'Lao',
//   lt: 'Lithuanian',
//   lu: 'Luba-Katanga',
//   lv: 'Latvian',
//   gv: 'Manx',
//   mk: 'Macedonian',
//   mg: 'Malagasy',
//   ms: 'Malay',
//   ml: 'Malayalam',
//   mt: 'Maltese',
//   mi: 'Maori',
//   mr: 'Marathi',
//   mh: 'Marshallese',
//   mn: 'Mongolian',
//   na: 'Nauru',
//   nv: 'Navajo, Navaho',
//   nd: 'North Ndebele',
//   ne: 'Nepali',
//   ng: 'Ndonga',
//   nb: 'Norwegian Bokmål',
//   nn: 'Norwegian Nynorsk',
//   no: 'Norwegian',
//   ii: 'Sichuan Yi, Nuosu',
//   nr: 'South Ndebele',
//   oc: 'Occitan',
//   oj: 'Ojibwa',
//   cu: 'Church Slavic, Old Slavonic, Church Slavonic, Old Bulgarian, Old Church Slavonic',
//   om: 'Oromo',
//   or: 'Oriya',
//   os: 'Ossetian, Ossetic',
//   pa: 'Punjabi, Panjabi',
//   pi: 'Pali',
//   fa: 'Persian',
//   pl: 'Polish',
//   ps: 'Pashto, Pushto',
//   pt: 'Portuguese',
//   qu: 'Quechua',
//   rm: 'Romansh',
//   rn: 'Rundi',
//   ro: 'Romanian, Moldavian, Moldovan',
//   ru: 'Russian',
//   sa: 'Sanskrit',
//   sc: 'Sardinian',
//   sd: 'Sindhi',
//   se: 'Northern Sami',
//   sm: 'Samoan',
//   sg: 'Sango',
//   sr: 'Serbian',
//   gd: 'Gaelic, Scottish Gaelic',
//   sn: 'Shona',
//   si: 'Sinhala, Sinhalese',
//   sk: 'Slovak',
//   sl: 'Slovenian',
//   so: 'Somali',
//   st: 'Southern Sotho',
//   es: 'Spanish, Castilian',
//   su: 'Sundanese',
//   sw: 'Swahili',
//   ss: 'Swati',
//   sv: 'Swedish',
//   ta: 'Tamil',
//   te: 'Telugu',
//   tg: 'Tajik',
//   th: 'Thai',
//   ti: 'Tigrinya',
//   bo: 'Tibetan',
//   tk: 'Turkmen',
//   tl: 'Tagalog',
//   tn: 'Tswana',
//   to: 'Tonga (Tonga Islands)',
//   tr: 'Turkish',
//   ts: 'Tsonga',
//   tt: 'Tatar',
//   tw: 'Twi',
//   ty: 'Tahitian',
//   ug: 'Uighur, Uyghur',
//   uk: 'Ukrainian',
//   ur: 'Urdu',
//   uz: 'Uzbek',
//   ve: 'Venda',
//   vi: 'Vietnamese',
//   vo: 'Volapük',
//   wa: 'Walloon',
//   cy: 'Welsh',
//   wo: 'Wolof',
//   fy: 'Western Frisian',
//   xh: 'Xhosa',
//   yi: 'Yiddish',
//   yo: 'Yoruba',
//   za: 'Zhuang, Chuang',
//   zu: 'Zulu',
